import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAppSelector } from '@/hooks/useAppSelector';
import { routePaths } from '@/routes/paths';

export function RequireAuth({ children }: PropsWithChildren) {
  const location = useLocation();
  const isAuthenticated = useAppSelector(state => state.auth.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={routePaths.auth.login} replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
